<template>
  <div>
    <div class="ui segment p-5">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <h2 class="m-1 text-dark">Login</h2>
        <h3>
          <p>Sign Up and Get Php 20.00 FREE Credits</p>
        </h3>
        <section id="firebaseui-auth-container"></section>

      </div>

    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import firebase from "firebase";
import * as firebaseui from "firebaseui";
import axios from "axios";

import "firebaseui/dist/firebaseui.css";
// import messaging from "firebase";
// import { ref } from "../../config/firebaseConfig";

export default {
  created: function () {},
  mounted() {
    var uiConfig = {
      signInFlow: "popup",
      signInSuccessUrl: "/",
      signInOptions: [
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      ],

      callbacks: {
        signInSuccessWithAuthResult: (authResult) => {
          let user = authResult.user;
          let new_user = authResult.additionalUserInfo.isNewUser; // User that was authenticate
          if (new_user === true) {
            // email subscription

            var data = JSON.stringify({
              email: user.email,
              name: user.displayName,
            });
            var config2 = {
              method: "post",
              url: "https://api.raffle.com.ph/subscribe",
              headers: {
                "Content-Type": "application/json",
              },
              data: data,
            };
            axios(config2)
              .then(function (response) {
                console.log(JSON.stringify(response.data));
              })
              .catch(function (error) {
                console.log(error);
              });

            //send welcome email
            let welcome_email =
              "<html lang='en'> <head> <meta name='viewport' content='width=device-width, initial-scale=1.0'> <link href='https://fonts.googleapis.com/css?family=NTR' rel='stylesheet'> <link rel='stylesheet' href='https://fonts.googleapis.com/icon?family=Material+Icons'> </head> <body> <div style='overflow-wrap: break-word; height: 800px; width:480px; margin-right: auto; margin-left: auto; font-family: ' NTR''> <div> <center> <div style='background-color: #6667AB;'> <img src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/raffle-cropped-white.png' style='width:180px; padding-top:15px; padding-left: 15px;' /> </div> </center> <center> <h1 style='font-family: ' NTR'; color: #6667AB;'>Welcome to raffle.com.ph</h1> <img src='https://media.giphy.com/media/dZXzmKGKNiJtDxuwGg/giphy.gif' style='width: 400px;' /> <div style='font-family: ' NTR'; color: #29282D; width: 430px; margin-top:1rem'> <p> You are now registered to the <strong>biggest</strong> and <strong>most legitimate</strong> raffle website in the Philippines. <br>You may enjoy 20 free credits upon sign up. </p> <div style='padding:10px'> <a href='https://www.raffle.com.ph' target='_blank' style='text-decoration: none; background-color: #6667AB; padding: 10px 20px; color: white; border-radius: 10px;'>Start Joining</a> </div> </div> <center> </div> <div style='width:100%; color: #26bca2; font-family: ' Merriweather Sans'; font-size:10px; padding-left:2rem'> <ul style='display: inline-block; list-style-type: none; margin: 0;padding: 0;'> <li style='float: left; padding:20px;'> <a href='https://www.raffle.com.ph' target='_blank' style='color: #6667AB;text-decoration: none;'> <img src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/web.png' style='width:16px; height:auto;vertical-align:middle' /> www.raffle.com.ph </a> </li> <li style='float: left; padding:20px;'> <a href='https://www.raffle.com.ph' target='_blank' style='color: #6667AB;text-decoration: none;'> <img src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/fb.png' style='width:16px; height:auto;vertical-align:middle' /> /raffle.com.ph </a> </li> <li style='float: left; padding:20px;'> <a href='https://www.raffle.com.ph' target='_blank' style='color: #6667AB;text-decoration: none;'> <img src='https://s3.ap-southeast-1.amazonaws.com/raffle.com.ph/ig.png' style='width:16px; height:auto;vertical-align:middle' /> /raffle.com.ph </a> </li> </ul> </div> </div> </body></html>";
            // console.log("welcome:", welcome_email);

            var emaildata = JSON.stringify({
              toAddresses: [user.email],
              textBody: "Hello",
              body: welcome_email,
              subject: "Welcome to raffle.com.ph",
              sender: "raffle.com.ph <hello@raffle.com.ph>",
            });
            var config = {
              method: "post",
              url: "https://8xyy3wc7yl.execute-api.ap-southeast-1.amazonaws.com/dev/sendEmail",
              headers: {
                "Content-Type": "application/json",
                "x-api-key": "be6V79mCxmwhJhSobKWa55l820J4oBX5Rd4aRMi9",
              },
              data: emaildata,
            };
            axios(config)
              .then(function (response) {
                console.log(JSON.stringify(response.data));
              })
              .catch(function (error) {
                console.log(error);
              });

            firebase
              .database()
              .ref("users/" + user.uid)
              .set({
                username: user.displayName,
                email: user.email,
                phone: "",
                profile_picture: user.photoURL,
                creationTime: user.metadata.creationTime,
                lastSignInTime: user.metadata.lastSignInTime,
                providerID: user.providerData[0].providerId,
              });
            let referred = user.uid;

            firebase
              .database()
              .ref("credits/" + user.uid)
              .set({
                credits: 20,
                creationTime: Date.now(),
              });

            this.$swal({
              title:
                "Enter email of your friend who referred you and get FREE Php 20 credit",
              html: `<input type="text" id="referral" class="swal2-input" placeholder="Referral ID">`,
              confirmButtonText: "Sign in",
              focusConfirm: false,
              preConfirm: () => {
                const referral = this.$swal
                  .getPopup()
                  .querySelector("#referral").value;
                return { referral };
              },
            }).then((result) => {
              firebase
                .database()
                .ref()
                .child("users")
                .orderByChild("email")
                .equalTo(result.value.referral)
                .on("value", function (snapshot) {
                  if (snapshot.exists()) {
                    snapshot.forEach(function (childSnapshot) {
                      var key = childSnapshot.key; // "ada"
                      firebase
                        .database()
                        .ref("referral/" + key + "/" + Date.now())
                        .set({
                          referredBy: referred,
                        });
                    });
                  } else {
                    console.log("doesn't exist");
                  }
                });
              firebase
                .database()
                .ref("credits/" + user.uid)
                .set({
                  credits: 20,
                  creationTime: Date.now(),
                });
            });
          }
          this.isLoading = false;
          this.$router.push("/");
        },
        signInFailure: (authResult) => {
          this.$swal("Login failed. Please try again.");
          console.log(authResult);
        },
      },
    };
    firebase.auth().useDeviceLanguage();
    var ui =
      firebaseui.auth.AuthUI.getInstance() ||
      new firebaseui.auth.AuthUI(firebase.auth());

    ui.start("#firebaseui-auth-container", uiConfig);
  },
  methods: {
    ...mapActions(["clearMessage", "addMessage", "addSlots"]),
    googleSignIn() {
      this.isLoading = true;
      let provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          let user = result.user;
          let new_user = result.additionalUserInfo.isNewUser; // User that was authenticate
          if (!new_user === true) {
            firebase
              .database()
              .ref("users/" + user.uid)
              .set({
                username: user.displayName,
                email: user.email,
                profile_picture: user.photoURL,
                creationTime: user.metadata.creationTime,
                lastSignInTime: user.metadata.lastSignInTime,
                providerID: user.providerData[0].providerId,
              });
            let referred = user.uid;

            firebase
              .database()
              .ref("credits/" + user.uid)
              .set({
                credits: 20,
                creationTime: Date.now(),
              });

            this.$swal({
              title:
                "Enter email of your friend who referred you and get FREE Php 20 credit",
              html: `<input type="text" id="referral" class="swal2-input" placeholder="Referral ID">`,
              confirmButtonText: "Sign in",
              focusConfirm: false,
              preConfirm: () => {
                const referral = this.$swal
                  .getPopup()
                  .querySelector("#referral").value;
                return { referral };
              },
            }).then((result) => {
              firebase
                .database()
                .ref()
                .child("users")
                .orderByChild("email")
                .equalTo(result.value.referral)
                .on("value", function (snapshot) {
                  if (snapshot.exists()) {
                    snapshot.forEach(function (childSnapshot) {
                      var key = childSnapshot.key; // "ada"
                      firebase
                        .database()
                        .ref("referral/" + key + "/" + Date.now())
                        .set({
                          referredBy: referred,
                        });
                    });
                  } else {
                    console.log("doesn't exist");
                  }
                });
              firebase
                .database()
                .ref("credits/" + user.uid)
                .set({
                  credits: 20,
                  creationTime: Date.now(),
                });
            });
          }
          this.isLoading = false;
          this.$router.push("/");
        })
        .catch((err) => {
          console.log(err); // This will give you all the information needed to further debug any errors
        });
    },
    fbSignIn() {
      this.isLoading = true;
      let provider = new firebase.auth.FacebookAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          // let token = result.credential.accessToken;
          let user = result.user;
          // console.log(token); // Token
          // console.log(user); // User that was authenticated
          firebase
            .database()
            .ref("users/" + "jchbasco@gmail.com")
            .set({
              username: user,
              email: "jchbasco@gmail.com",
              profile_picture: "test",
            });

          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err); // This will give you all the information needed to further debug any errors
        });
    },
  },
};
</script>
<style>
.fb-signin-button {
  border: none;
  color: #fff;
  position: relative;
  line-height: 34px;
  min-width: 225px;
  padding: 0 15px 0px 46px;
  background-image: linear-gradient(#4c69ba, #3b55a0);
}
.google-signin-button {
  display: inline-block;
  background: white;
  color: #444;
  width: 190px;
  border-radius: 5px;
  border: thin solid #888;
  box-shadow: 1px 1px 1px grey;
  white-space: nowrap;
}
.login-page {
  align-items: center;
  display: flex;
  height: 100vh;
}
body,
#content {
  width: 100%;
  height: 100%;
}

img {
  width: 56px;
  height: 48px;
}

h1 {
  font-weight: 200;
  font-style: 26px;
  margin: 10px;
}
</style>
